import type { ReactNode } from 'react';
import { EntityInfoCard } from '@backstage/plugin-catalog-react';
import { Alert, Flex, Text } from '@backstage/ui';

import { CodeSnippet } from '@backstage/core-components';

/** Shared presentational shell for the AiResource install cards. */
export const InstallCard = ({
  warning,
  requires,
  command,
}: {
  warning: string;
  requires: ReactNode;
  command: string;
}) => (
  <EntityInfoCard title="Install">
    <Flex direction="column" gap="3">
      <Alert status="warning" icon title={warning} />
      <Text>Requires the {requires}.</Text>
      <CodeSnippet language="sh" text={command} showCopyCodeButton />
    </Flex>
  </EntityInfoCard>
);
